import _ from 'underscore'
import React from 'react'
import moment from 'moment'

class Timeago extends React.Component {
  render() {
    if (_.isEmpty(this.props.date)) {
      return null
    }

    const date = this.props.date
    const formatted = moment(date).format('ddd Do MMM YYYY [at] HH:mm')

    const sameElse = (moment(date).year() !== moment().year()) ?
      'D MMM YYYY'
    :
      'D MMM'

    const fromnow = moment(date).calendar(null, {
      sameDay: 'HH:mm',
      nextDay: '[Tomorrow]',
      nextWeek: 'D MMM',
      lastDay: '[Yesterday]',
      lastWeek: 'D MMM',
      sameElse : sameElse
    })

    return (
      <span title={formatted}>{fromnow}</span>
    )
  }
}

export default Timeago